if (!customElements.get('collection-banner-parallax')) {
  customElements.define('collection-banner-parallax',
    class CollectionBannerParallax extends HTMLElement {
      constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.img = null;
      }

      connectedCallback() {
        this.img = this.querySelector('[data-parallax-img]');
        if (!this.img) return;

        // Baseline: how far the page had already been scrolled the moment
        // this section mounted. The offset below is measured relative to
        // THIS, not raw scroll position — a banner sitting under the
        // header already has a rect.top of 60-100+px even at scrollY 0, so
        // keying the offset directly off rect.top (the old formula) shifted
        // the image upward from the very first frame, before the visitor
        // had scrolled at all. That cropped the top of the image and
        // showed more of its lower half by default — the "background
        // image seems a bit low" report. Measuring from this baseline
        // keeps the offset at 0 until the visitor actually scrolls.
        this.initialScrollY = window.scrollY;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.handleScroll.bind(this));
        }

        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
      }

      handleScroll() {
        if (!this.img) return;
        const parallaxSpeed = 0.2;
        const scrollDelta = window.scrollY - this.initialScrollY;
        // The image box sits flush with the container's top edge at rest
        // (top: 0%) and is 140% tall, so the entire 40% of extra height is
        // reserved BELOW — the only direction the image ever needs to
        // travel, since scrolling down moves it upward. Clamping the upper
        // bound at 0 keeps it from ever being pushed down past its resting
        // position, which would crop the image's true top edge into view
        // from empty space above it. Clamping the lower bound at -maxOffset
        // stops it moving up far enough to expose the background below.
        const maxOffset = this.getBoundingClientRect().height * 0.4;
        const yPos = Math.max(-maxOffset, Math.min(0, -(scrollDelta * parallaxSpeed)));
        gsap.set(this.img, { y: yPos, force3D: true });
      }
    }
  );
}
